import React from 'react';
import {
  Alert,
  AlertTitle,
  Box, Button, Container, Stack, Typography,
} from '@mui/material';
import { Fab } from '@marageti/z4-lib';
import CountryCard from '../../../../components/country-card';
import { ViewProps } from './types';
import ConfirmDelete from '../../../../components/confirm-delete';
import CountryEditForm from '../../../../components/partner-country-edit';

const CountriesView = ({
  countryDefault,
  editorState,
  excludedCountries,
  onCancelDelete,
  onClickCreate,
  onClickDelete,
  onClickEdit,
  onClose,
  onConfirmDelete,
  onSubmit,
  primaryCountries,
  secondaryCountries,
  settingToDelete,
  showModal,
  submissionError,
}: ViewProps) => (
  <Container maxWidth="md">
    <Box
      sx={{
        py: 3,
        pb: { desktop: 6.5 + 10.5, mobile: 3.5 + 10.5 }, // 10.5 * 8px spacing for 85px fab.
      }}
    >
      {submissionError && (
      <Alert severity="error" sx={{ mt: 4 }}>
        <AlertTitle>There was an error on our end.</AlertTitle>
        {`Code: ${submissionError.code}: ${submissionError.message}`}
        <br />
        {submissionError.id && `ID: ${submissionError.id}`}
      </Alert>
      )}
      <Typography variant="h2" sx={{ mb: 5 }}>Countries</Typography>
      <Box sx={{ mb: 3.75 }}>
        <Typography component="h2" variant="h3" marginBottom={2}>
          Primary
        </Typography>
        <Stack spacing={1.5}>
          {primaryCountries?.map((c) => (
            <CountryCard
              key={c.country}
              displayName={c.displayName}
              minNights={0}
              minBudgetPPPD={c.minBudgetPPPD}
              onClickEdit={() => onClickEdit(c)}
              onClickDelete={() => onClickDelete(c)}
            />
          ))}
        </Stack>
      </Box>
      <Box>
        <Typography component="h2" variant="h3" marginBottom={2}>
          Secondary
        </Typography>
        <Stack spacing={1.5}>
          {secondaryCountries?.map((c) => (
            <CountryCard
              key={c.country}
              displayName={c.displayName}
              minNights={0}
              minBudgetPPPD={c.minBudgetPPPD}
              onClickEdit={() => onClickEdit(c)}
              onClickDelete={() => onClickDelete(c)}
            />
          ))}
        </Stack>
      </Box>
    </Box>
    <Fab
      anchorId="oryx-footer"
    >
      <Button
        variant="contained"
        disabled={!countryDefault}
        onClick={onClickCreate}
        sx={{
          minWidth: { mobile: '350px', desktop: 'fit-content' },
        }}
      >
        Add Country
      </Button>
    </Fab>
    <ConfirmDelete
      open={!!settingToDelete}
      onCancel={onCancelDelete}
      onRemove={onConfirmDelete}
      title={`Remove ${settingToDelete?.displayName || ''}?`}
    />
    { countryDefault && (
      <CountryEditForm
        open={showModal}
        partnerCountry={editorState}
        onAddCountry={onSubmit}
        onClose={onClose}
        excludeCodes={excludedCountries}
      />
    )}
  </Container>
);

export default CountriesView;
